import { render, staticRenderFns } from "./ChallengeInfo.vue?vue&type=template&id=133a9c31&scoped=true"
import script from "./ChallengeInfo.vue?vue&type=script&lang=js"
export * from "./ChallengeInfo.vue?vue&type=script&lang=js"
import style0 from "./ChallengeInfo.vue?vue&type=style&index=0&id=133a9c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a9c31",
  null
  
)

export default component.exports